/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PurchaseIteration } from './PurchaseIteration';
const BasePurchaseSummaryParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['successAt', parsers.moment, 'success_at'],
    ['itemPurchaseIteration', PurchaseIteration, 'item_purchase_iteration'],
]);
export class BasePurchaseSummary extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BasePurchaseSummaryParser.decode(input).map(res => new BasePurchaseSummary(res));
    }
    static unsafeDecode(input) {
        return BasePurchaseSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BasePurchaseSummaryParser.encode(data);
    }
    static schema() {
        return BasePurchaseSummaryParser.schema();
    }
}
